import { config } from "../Environment";

type RetryFetch = (url: string, options?: RequestInit) => Promise<Response>;

/**
 * Web Push API — pairs with ClaryNext-BE /api/push/* routes.
 * The VAPID public key endpoint is unauthenticated; 503 means the server has
 * no VAPID keys configured and the feature should stay hidden.
 */

export async function getVapidPublicKey(): Promise<string | null> {
  try {
    const response = await fetch(`${config.API_BASE}/api/push/public-key`);
    if (!response.ok) return null;
    const data = await response.json();
    return data.publicKey ?? null;
  } catch {
    return null;
  }
}

export async function savePushSubscription(
  retryFetch: RetryFetch,
  subscription: PushSubscription
): Promise<boolean> {
  const response = await retryFetch(`${config.API_BASE}/api/push/subscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      subscription: subscription.toJSON(),
      userAgent: navigator.userAgent,
    }),
  });
  return response.ok;
}

export async function removePushSubscription(
  retryFetch: RetryFetch,
  endpoint: string
): Promise<boolean> {
  const response = await retryFetch(`${config.API_BASE}/api/push/unsubscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ endpoint }),
  });
  return response.ok;
}

export async function sendTestPush(retryFetch: RetryFetch): Promise<{ sent: number }> {
  const response = await retryFetch(`${config.API_BASE}/api/push/test`, {
    method: "POST",
  });
  if (!response.ok) throw new Error("Test push failed");
  return response.json();
}
